import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { provider } from '../../providers/provider';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';
import { productDetailPage } from '../productDetail/productDetail';
import { CustomizerProvider } from '../../providers/customizer/customizer';

@Component({
  selector: 'page-search',
  templateUrl: 'search.html'
})
export class Search {
  menu: any;
  searchQuery: string = '';
  i = [];
  items = [];
  data: any;
  url: any;
  allergeni = ["ANIDRIDE SOLFOROSA","ARACHIDI","CROSTACEI","FRUTTA A GUSCIO","GLUTINE","LATTE","LUPINI","MOLLUSCHI","PESCE","SEDANO","SENAPE","SESAMO","SOIA","UOVA","SPEZIE"];
  choice = 'prod';
  
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public provider: provider,
    public storage: Storage,
    public translateService: TranslateService,
    public customizer: CustomizerProvider) {

    this.data = provider.getMenu();
    this.url = provider.getUrl();

    if (this.data) {
      this.data.menu.righe.filter(riga => riga.contentType == 'ProdVarIngr').map(riga => {
        // filter NON main description from rows
        let menuItem : any = provider.deepCloneObject(riga)
        menuItem.content.descrizione = menuItem.content.descrizione.filter(descrizione => {          
          return (descrizione.lingua == this.translateService.currentLang.toUpperCase() || descrizione.main)
        })
        this.i.push(menuItem)
      })
      this.initializeItems();
    }
    else {
      console.log('data is undefined')
    }

  }

  getImg(img) {
    return 'assets/ALLERGENI/' + img + '.png';
  }

  showProduct(product) {
    this.navCtrl.push(productDetailPage, { product: product });
  }

  initializeItems() {
    this.items = this.i;
  }

  getItemsWithAllergeni(allergen) {
    this.initializeItems();
    this.items = this.items.filter((v) => {
      for(let i=0;i < v.content.extraProps.iconeAllergeni.length; i++) {
        if (v.content.extraProps.iconeAllergeni[i] == allergen) {
            return true;
        }
        return false;
      }
    })
  }

  getVeggyItems() {
    this.initializeItems();
    this.items = this.items.filter((v) => {
      if (v.content.extraProps.vegetariano) {
          return true;
      }
      return false;
    })
  }

  getVeganItems() {
    this.initializeItems();
    this.items = this.items.filter((v) => {
      if (v.content.extraProps.vegano) {
          return true;
      }
      return false;
    })
  }

  getItems(searchbar) {
    this.initializeItems();

    var q = searchbar.target.value;
    if (q == '' || q == undefined) {
      return;
    }
    else {
      this.items = this.items.filter((v) => {
        if (v.content.descrizione[0].contenuto.toLowerCase().indexOf(q.toLowerCase()) > -1)
          return true;

        return false;
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/search/search.ts